@if (updateAvailable$ | async) {
  <div class="update-banner">
    <ion-icon name="cloud-download-outline"></ion-icon>
    <span>{{ 'updateBanner.message' | tr }}</span>
    <button class="update-banner__btn" (click)="reload()" [disabled]="isReloading">
      {{ 'updateBanner.reload' | tr }}
    </button>
  </div>
}
